import * as angular from 'angular';

export interface IHubspotField {
    name: string;
    value: any;
}

export class FiHubspotService {

    static $inject = [
        '$http',
    ];

    constructor(
        private $http: angular.IHttpService,
    ) {
    }

    // Sent through our server, which verifies the reCAPTCHA token (from <fi-recaptcha>) and only then forwards the data to the HubSpot form.
    // The request goes out within the same click, so it is already sent when an order page then leaves for Paysera.
    submit(token: string, pageUri: string, pageName: string, fields: IHubspotField[]) {
        const data = {
            "submittedAt": new Date().getTime(),
            "fields": fields.map((field) => ({
                "objectTypeId": "0-1",
                "name": field.name,
                "value": field.value
            })),
            "context": {
                // "hutk": ':hutk', // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
                "pageUri": pageUri,
                "pageName": pageName
            },
            "legalConsentOptions":{ // Include this object when GDPR options are enabled
                "consent":{
                "consentToProcess":true,
                "text":"I agree to allow Example Company to store and process my personal data.",
                "communications":[
                    {
                    "value":true,
                    "subscriptionTypeId":999,
                    "text":"I agree to receive marketing communications from Example Company."
                    }
                ]
                }
            }
        };

        this.$http.post("https://www.fitit.lt/db/hubspot-submit.php", {
            token: token,
            submission: data
        }, { headers: {'Content-Type': 'application/json'} })
            .catch((error) => console.warn('HubSpot submission failed', error));
    }
}
